import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
  },

  addButton: {
    display: 'flex',
    flexDirection: 'row-reverse',

    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem !important',
      color: '#3024E1 !important',
      cursor: 'pointer',
      transition: 'all 350ms ease-in-out',

      '&:hover': {
        color: `${getRGBA('#3024E1', 0.6)} !important`,
      },
    },
  },

  loadingBase: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '12.5rem',
  },

  initialBase: {
    display: 'flex',
    height: '12.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.15rem',

    '& .MuiSvgIcon-root': {
      fontSize: '1rem !important',
      color: '#3024E1 !important',
    },
  },

  initialBaseText: {
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: getRGBA('#0F0F1E99', 0.6),
  },

  // Table

  tableBase: {
    width: '100%',
    overflowX: 'auto',
  },

  tableHeader: {
    '& th': {
      fontFamily: 'Nunito',
      fontWeight: '600',
      fontSize: '0.875rem',
      lineHeight: '2rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  tableBody: {
    '& td': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  tableOthersSize: {
    width: '4.6rem',
    maxWidth: '4.6rem',
    padding: '0.25rem 0',
    overflow: 'hidden',
    height: '5.5625rem',
    maxHeight: '5.5625rem',

    '& span': {
      textTransform: 'capitalize',
    },
  },

  tableActionSize: {
    width: '2%',
    minWidth: '2%',
    maxWidth: '2%',
    padding: '0.25rem 1rem',
  },

  tableOpacityRecipeName: {
    color: getRGBA('#0F0F1E', 0.38),
  },

  searchInput: {
    width: '100%',
    border: 'none',
    outline: 'none',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#191C1A',
    borderRadius: '0.15rem',
    padding: '0.25rem',
  },

  alertBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '0.75rem',
    padding: '0.5rem 1rem',
    marginBottom: '0.25rem',
    borderRadius: '0.5rem',
    backgroundColor: '#FFF4E5',
  },

  alertText: {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',

    '& strong': {
      color: '#663C00',
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },

    '& span': {
      fontFamily: 'Nunito',
      fontWeight: '600 !important',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#663C00 !important',
    },
  },

  hint: {
    fontFamily: 'Nunito',
    fontWeight: '700',
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    padding: '0.25rem 0',
    color: getRGBA('#FF0000', 0.6),
  },

  inputDate: {
    '& .MuiFilledInput-input': {
      backgroundColor: '#FFFFFF !important',
    },

    '& .MuiInput-input:focus': {
      backgroundColor: '#FFFFFF !important',
    },
  },

  // Actions Buttons

  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    paddingTop: '1.5rem',
  },

  submitButton: {
    height: '2.25rem !important',
    padding: '1rem 1.5rem !important',
  },

  cancelButton: {
    height: '2.25rem !important',
    padding: '1rem 1.5rem !important',
    color: '#BA1A1A !important',
    border: `1px solid ${getRGBA('#BA1A1A', 0.5)} !important`,
  },
}))

export { useStyles }
